import { FrontendPath } from '@/common'
import { EquipmentVariant, Profile } from '@/types/profile'
import classNames from 'classnames'
import { CSSProperties, useCallback, useMemo, useState } from 'react'
import Paperdoll from './Paperdoll'
import './PaperdollWithSets.scss'

export function PaperdollWithSets({
  profileId,
  planner,
  sets,
  style
}: {
  profileId: string
  planner: Profile
  sets: string[]
  style: CSSProperties | undefined
}) {
  const allVariants = useMemo(() => planner.equipment.variants, [planner.equipment.variants])
  const variants: EquipmentVariant[] = useMemo(() => {
    let result = sets.map((set) => allVariants.find((variant, index) => variant.id === set || `${index}` === set))
    if (result.length === 0 || !result[0]) result = [allVariants[0]]
    return result.filter((variant): variant is EquipmentVariant => !!variant)
  }, [allVariants, sets])

  const [activeSetId, setActiveSetId] = useState(sets[0] ?? variants?.[0]?.id ?? '')

  const items = useMemo(() => {
    let result = variants.find((variant) => variant?.id === activeSetId)?.items
    if (!result) result = variants[0]?.items
    return result ?? []
  }, [activeSetId, variants])

  const onVariantClick = useCallback((id: string | undefined) => () => setActiveSetId(id || ''), [])

  const onPaperdollClick = useCallback(() => {
    window.location.href = `${FrontendPath}/poe/planner/${profileId}`
  }, [profileId])

  return (
    <div className={classNames('poe-paperdoll-wrapper', sets.length > 1 && 'poe-paperdoll-wrapper-multiset')}>
      {sets.length > 1 ? (
        <div className="poe-variants-container">
          <div className="poe-variants">
            {variants.map((variant, index) => {
              const isNonEmpty = Object.values(variant.items).some(Boolean)
              const showVariant = isNonEmpty

              return showVariant ? (
                <div
                  key={index}
                  className={classNames('poe-tab', activeSetId === variant?.id && 'poe-active')}
                  onClick={onVariantClick(variant?.id)}>
                  {variant.name || `Set ${index + 1}`}
                </div>
              ) : undefined
            })}
          </div>
        </div>
      ) : null}

      <a
        className="poe-paperdoll-inner"
        target="_blank"
        rel="noopener noreferrer"
        href={`${FrontendPath}/poe/planner/${profileId}`}>
        <Paperdoll items={items} selected={undefined} onSelect={undefined} style={style} />
      </a>
    </div>
  )
}
